import { getFetcher } from '../../api';
import { useAuth } from '../useAuth';

export function useFetcher(init?: RequestInit) {
  const { token } = useAuth();
  return getFetcher(token, init);
}

export function usePublicFetcher(init?: RequestInit) {
  return getFetcher('', init);
}
